import { jsxs as a, jsx as o, Fragment as g } from "react/jsx-runtime";
import x from "react";
import { u as i } from "./index-6a632112.mjs";
import { s as m, d, e as n, c as h } from "./themes-5f0b3c3d.mjs";
import { Tooltip as y } from "./tooltip.js";
import { PopupTip as T } from "./popupTip.js";
import { S as $ } from "./checkmarkFilled-c2b01ef1.mjs";
import { S as c } from "./informationFilled-05d57719.mjs";
const S = i.div`
  display: flex;
  align-items: center;
  gap: ${m["3x"]};
  align-self: stretch;
`, C = i.label`
  display: flex;
  align-items: center;
  text-align: left;
  flex: 1 0 0;
  color: ${(e) => e.theme.components.label.labelColor};
  font-family: ${d.body};
  font-size: ${n.medium.S.fontSize};
  font-style: normal;
  font-weight: ${n.medium.S.fontWeight};
  line-height: ${n.medium.S.lineHeight};
`, b = i.span`
  text-align: right;
  color: ${(e) => e.theme.components.label.optionalTextColor};
  font-family: ${d.body};
  font-size: ${n.medium.S.fontSize};
  font-style: normal;
  font-weight: ${n.medium.S.fontWeight};
  line-height: ${n.medium.S.lineHeight};
`, p = i.span`
  color: ${(e) => e.theme.components.label.optionalTextColor};
  margin-top: 3px;
  svg {
    color: ${(e) => e.theme.components.label.infoIconColor};
  }
`, v = i.span`
  color: ${h.utilityDanger[1e3]};
  margin-left: ${m["1x"]};
`, W = i.div`
  display: flex;
  align-items: center;
`, k = i.div``;
function j({
  labelProp: e,
  infoProp: t,
  trailingText: r,
  trailingElement: s,
  as: f = "div"
}) {
  const l = (u) => {
    u.stopPropagation();
  };
  return (e?.label || e?.showRequiredIndicator || e?.success || t?.infoText || r || x.isValidElement(s)) && /* @__PURE__ */ a(S, { onClick: l, as: f, children: [
    /* @__PURE__ */ a(C, { htmlFor: e?.htmlFor, id: e?.id, children: [
      e?.label,
      e?.showRequiredIndicator && /* @__PURE__ */ o(v, { "aria-hidden": "true", children: " *" }),
      e?.success && /* @__PURE__ */ o(
        $,
        {
          width: 16,
          height: 16,
          color: h.utilitySuccess[1e3],
          style: { marginLeft: 8 }
        }
      )
    ] }),
    r && /* @__PURE__ */ o(b, { onClick: l, children: r }),
    s && /* @__PURE__ */ o(W, { children: s }),
    t?.infoText && (t.infoType === "tooltip" ? /* @__PURE__ */ o(k, { children: /* @__PURE__ */ o(y, { placement: "auto", title: t.infoText, children: /* @__PURE__ */ o(p, { onClick: l, children: /* @__PURE__ */ o(c, { size: "xxs" }) }) }) }) : t.infoType === "popuptip" ? /* @__PURE__ */ o(
      p,
      {
        onClick: l,
        onFocus: l,
        children: /* @__PURE__ */ o(
          T,
          {
            placement: "auto",
            popupTipBody: t?.infoText,
            popupTipHeader: t.popupTipHeader,
            showButton: !1,
            children: /* @__PURE__ */ o(c, { size: "xxs" })
          }
        )
      }
    ) : "")
  ] }) || /* @__PURE__ */ o(g, {});
}
export {
  j as L
};
